<template>
    <div
        class="container-fluid myCoursesWeeduc weeduc-admin-courses page-card edit-courses-page text-left"
    >
        <header class="edit-courses-header">
            <div class="edit-courses-header__lead">
                <TitlePage
                    title="Meus Cursos"
                    subtitle="Gerencie seus cursos ou crie novos. Arraste-os para mudar a ordem de visualização no portal do aluno."
                    :hasMargin="false"
                />
            </div>
            <div class="edit-courses-header__actions">
                <v-btn
                    variant="flat"
                    color="primary"
                    rounded="lg"
                    title="Criar novo curso"
                    :icon="$vuetify.display.xs"
                    class="text-none edit-courses-new-btn"
                    @click="() => $router.push('/dashboard/form-curso')"
                >
                    <template v-if="$vuetify.display.xs">
                        <v-icon>mdi-plus</v-icon>
                    </template>
                    <template v-else>
                        <v-icon class="me-1" size="small">mdi-plus</v-icon>
                        Novo curso
                    </template>
                </v-btn>
            </div>
        </header>

        <div class="edit-courses-shell">
            <section class="edit-courses-stats" aria-label="Resumo">
                <article class="edit-courses-stat-card">
                    <div class="edit-courses-stat-card__icon" aria-hidden="true">
                        <fa icon="fa-graduation-cap" />
                    </div>
                    <div class="edit-courses-stat-card__body">
                        <span class="edit-courses-stat-card__label">Cursos</span>
                        <strong class="edit-courses-stat-card__value">{{
                            numberCourses
                        }}</strong>
                    </div>
                </article>
                <article class="edit-courses-stat-card">
                    <div class="edit-courses-stat-card__icon" aria-hidden="true">
                        <fa icon="fa-list" />
                    </div>
                    <div class="edit-courses-stat-card__body">
                        <span class="edit-courses-stat-card__label">Módulos</span>
                        <strong class="edit-courses-stat-card__value">{{
                            numberModules
                        }}</strong>
                    </div>
                </article>
                <article class="edit-courses-stat-card">
                    <div class="edit-courses-stat-card__icon" aria-hidden="true">
                        <fa icon="fa-book-open" />
                    </div>
                    <div class="edit-courses-stat-card__body">
                        <span class="edit-courses-stat-card__label">Aulas</span>
                        <strong class="edit-courses-stat-card__value">{{
                            numberLessons
                        }}</strong>
                    </div>
                </article>
            </section>

            <div class="edit-courses-list-panel">
                <div class="edit-courses-list-panel__head">
                    <h2 class="edit-courses-list-panel__title">Catálogo de cursos</h2>
                    <p class="edit-courses-list-panel__lead">
                        Filtre por nome e status e escolha como visualizar os cards.
                    </p>
                </div>

                <div class="edit-courses-toolbar">
                    <div class="edit-courses-toolbar__controls">
                        <div class="edit-courses-toolbar__field edit-courses-toolbar__field--search">
                            <v-text-field
                                type="text"
                                v-model="searchText"
                                label="Buscar"
                                placeholder="Nome do curso..."
                                variant="outlined"
                                hide-details
                                density="compact"
                                class="inputd edit-courses-v-field weeduc-admin-v-field"
                                append-inner-icon="mdi-magnify"
                                clearable
                                @input="buscarColecao"
                                @click:clear="buscarColecao"
                            />
                        </div>
                        <div class="edit-courses-toolbar__field edit-courses-toolbar__field--status">
                            <v-select
                                v-model="statusFilter"
                                :items="statusFilterOptions"
                                item-title="text"
                                item-value="value"
                                label="Status"
                                variant="outlined"
                                class="inputd edit-courses-v-field weeduc-admin-v-field"
                                density="compact"
                                hide-details
                                :menu-props="coursesSelectMenuProps"
                                @update:modelValue="filtrarPorStatus"
                            />
                        </div>
                        <div
                            class="edit-courses-toolbar__field edit-courses-toolbar__field--view"
                            role="group"
                            aria-label="Modo de visualização"
                        >
                            <div class="edit-courses-view-segment">
                                <button
                                    type="button"
                                    class="edit-courses-seg-btn"
                                    :class="{ active: view === 1 }"
                                    @click="changeView(1)"
                                    title="Blocos"
                                >
                                    <v-icon size="small">mdi-view-grid</v-icon>
                                    <span class="edit-courses-seg-btn__text">Blocos</span>
                                </button>
                                <button
                                    type="button"
                                    class="edit-courses-seg-btn"
                                    :class="{ active: view === 2 }"
                                    @click="changeView(2)"
                                    title="Lista"
                                >
                                    <v-icon size="small">mdi-view-list</v-icon>
                                    <span class="edit-courses-seg-btn__text">Lista</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="edit-courses-grid-wrap">
        <!-- *** CHANGE 1: Added v-if condition to disable draggable on mobile screens *** -->
        <draggable
            v-if="!isMobileIcon"
            :list="collections"
            :disabled="false"
            class="list-group"
            :class="{
                'edit-courses-card-grid': view === 1,
                'edit-courses-card-list': view === 2,
            }"
            ghost-class="ghost"
            :move="checkMove"
            @start="dragging = true"
            @end="onDragEnd"
        >
            <template #item="{ element }">
                <div
                    class="list-group-item myCoursesWeeduc edit-courses-card"
                    :id="`collection-${element.id}`"
                >
                    <div
                        class="item edit-courses-card__inner"
                        @click="goToCollection(element.id, element)"
                    >
                        <div class="drag-handle" v-if="dragging">
                            <v-icon>mdi-drag</v-icon>
                        </div>
                        <div
                            class="backgroundItemCollection edit-courses-card__thumb"
                            :class="{ noImage: !element.imageFinalPath2 }"
                            :style="{
                                backgroundImage: element.imageFinalPath2
                                    ? `url('${element.imageFinalPath2}')`
                                    : `url('${require('@/assets/Weflix/default-video-thumbnail.jpg')}')`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }"
                        >
                            <span
                                v-if="view === 1"
                                class="edit-courses-card__badge"
                                :class="
                                    isCourseActive(element)
                                        ? 'edit-courses-card__badge--active'
                                        : 'edit-courses-card__badge--inactive'
                                "
                            >
                                {{
                                    isCourseActive(element)
                                        ? 'Ativo'
                                        : 'Inativo'
                                }}
                            </span>
                        </div>
                        <div
                            class="itemContent edit-courses-card__body"
                            :class="{ noImage: !element.imageFinalPath }"
                        >
                            <div class="titleItemCollection edit-courses-card__text">
                                <span class="edit-courses-card-title">{{
                                    element.comercialName
                                }}</span>
                                <small
                                    v-if="descriptionPreview(element)"
                                    class="edit-courses-card-desc"
                                    >{{ descriptionPreview(element) }}</small
                                >
                            </div>
                            <div
                                v-if="view === 1"
                                class="edit-courses-card__footer"
                            >
                                <span class="edit-courses-card__stat">
                                    <v-icon
                                        class="edit-courses-card__stat-icon"
                                        size="14"
                                        >mdi-view-module</v-icon
                                    >
                                    {{ Number(element.moduleQty) || 0 }} módulos
                                </span>
                                <span class="edit-courses-card__stat">
                                    <v-icon
                                        class="edit-courses-card__stat-icon"
                                        size="14"
                                        >mdi-book-open-variant</v-icon
                                    >
                                    {{ Number(element.lessonQty) || 0 }} aulas
                                </span>
                            </div>
                            <div
                                v-else
                                class="edit-courses-card__footer edit-courses-card__footer--list"
                            >
                                <span class="edit-courses-card__stat">{{
                                    Number(element.moduleQty) || 0
                                }}
                                    mód.</span>
                                <span
                                    class="edit-courses-card__stat-sep"
                                    aria-hidden="true"
                                    >·</span
                                >
                                <span class="edit-courses-card__stat">{{
                                    Number(element.lessonQty) || 0
                                }}
                                    aulas</span>
                                <span
                                    class="edit-courses-card__stat-sep"
                                    aria-hidden="true"
                                    >·</span
                                >
                                <span
                                    class="edit-courses-card__stat"
                                    :class="
                                        isCourseActive(element)
                                            ? 'edit-courses-card__stat--ok'
                                            : 'edit-courses-card__stat--off'
                                    "
                                >
                                    {{
                                        isCourseActive(element)
                                            ? 'Ativo'
                                            : 'Inativo'
                                    }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </draggable>

        <!-- *** CHANGE 2: Added v-else block for non-draggable version on mobile *** -->
        <div
            v-else
            class="list-group"
            :class="{
                'edit-courses-card-grid': view === 1,
                'edit-courses-card-list': view === 2,
            }"
        >
            <div
                v-for="element in collections"
                :key="element.id"
                class="list-group-item myCoursesWeeduc edit-courses-card"
                :id="`collection-${element.id}`"
            >
                <div
                    class="item edit-courses-card__inner"
                    @click="goToCollection(element.id, element)"
                >
                    <div
                        class="backgroundItemCollection edit-courses-card__thumb"
                        :class="{ noImage: !element.imageFinalPath2 }"
                        :style="{
                            backgroundImage: element.imageFinalPath2
                                ? `url('${element.imageFinalPath2}')`
                                : `url('${require('@/assets/Weflix/default-video-thumbnail.jpg')}')`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }"
                    >
                        <span
                            v-if="view === 1"
                            class="edit-courses-card__badge"
                            :class="
                                isCourseActive(element)
                                    ? 'edit-courses-card__badge--active'
                                    : 'edit-courses-card__badge--inactive'
                            "
                        >
                            {{
                                isCourseActive(element) ? 'Ativo' : 'Inativo'
                            }}
                        </span>
                    </div>
                    <div
                        class="itemContent edit-courses-card__body"
                        :class="{ noImage: !element.imageFinalPath }"
                    >
                        <div class="titleItemCollection edit-courses-card__text">
                            <span class="edit-courses-card-title">{{
                                element.comercialName
                            }}</span>
                            <small
                                v-if="descriptionPreview(element)"
                                class="edit-courses-card-desc"
                                >{{ descriptionPreview(element) }}</small
                            >
                        </div>
                        <div
                            v-if="view === 1"
                            class="edit-courses-card__footer"
                        >
                            <span class="edit-courses-card__stat">
                                <v-icon
                                    class="edit-courses-card__stat-icon"
                                    size="14"
                                    >mdi-view-module</v-icon
                                >
                                {{ Number(element.moduleQty) || 0 }} módulos
                            </span>
                            <span class="edit-courses-card__stat">
                                <v-icon
                                    class="edit-courses-card__stat-icon"
                                    size="14"
                                    >mdi-book-open-variant</v-icon
                                >
                                {{ Number(element.lessonQty) || 0 }} aulas
                            </span>
                        </div>
                        <div
                            v-else
                            class="edit-courses-card__footer edit-courses-card__footer--list"
                        >
                            <span class="edit-courses-card__stat">{{
                                Number(element.moduleQty) || 0
                            }}
                                mód.</span>
                            <span
                                class="edit-courses-card__stat-sep"
                                aria-hidden="true"
                                >·</span
                            >
                            <span class="edit-courses-card__stat">{{
                                Number(element.lessonQty) || 0
                            }}
                                aulas</span>
                            <span
                                class="edit-courses-card__stat-sep"
                                aria-hidden="true"
                                >·</span
                            >
                            <span
                                class="edit-courses-card__stat"
                                :class="
                                    isCourseActive(element)
                                        ? 'edit-courses-card__stat--ok'
                                        : 'edit-courses-card__stat--off'
                                "
                            >
                                {{
                                    isCourseActive(element)
                                        ? 'Ativo'
                                        : 'Inativo'
                                }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                </div>

                <div
                    v-if="collections.length === 0 && hasReady"
                    class="edit-courses-empty"
                >
                    Nenhum curso encontrado.
                </div>
            </div>
        </div>
    </div>
    <Loader :hasReady="hasReady" />
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import apiCollections from '@/utils/Weflix/collections';
    import Loader from '@/components/Weflix/Loader';
    import draggable from 'vuedraggable';
    import ApiModules from '@/utils/modules';
    import TitlePage from '@/components/Weflix/titlePage.vue';
    import { VSelect } from 'vuetify/components';

    let id = 1;

    export default {
        data() {
            return {
                collections: [],
                hasReady: false,
                dragging: false,
                showCollections: false,
                isMobileIcon: false,
                searchText: '',
                view: 1,
                numberCourses: 0,
                numberModules: 0,
                numberLessons: 0,
                allCollections: [],
                searchDebounceTimeout: null,
                statusFilter: '1',
                statusFilterOptions: [
                    { text: 'Todos', value: 'all' },
                    { text: 'Ativos', value: '1' },
                    { text: 'Inativos', value: '4' },
                ],
            };
        },
        mounted() {
            this.checkScreenSize();
            window.addEventListener('resize', this.checkScreenSize);
        },
        beforeDestroy() {
            if (this.searchDebounceTimeout) {
                clearTimeout(this.searchDebounceTimeout);
            }
            window.removeEventListener('resize', this.checkScreenSize);
        },
        computed: {
            ...mapState(['token', 'panelData', 'currentCollections', 'dark']),
            coursesSelectMenuProps() {
                return this.dark
                    ? { contentClass: 'weeduc-courses-select-menu-dark' }
                    : {};
            },
        },
        methods: {
            ...mapActions(['storeCurrentCollections']),

            goToCollection(id, collections) {
                this.storeCurrentCollections({
                    currentCollections: collections,
                });
                this.$router.push('/dashboard/curso');
            },
            async getCollections() {
                try {
                    const response = await apiCollections.getCollection(
                        this.token
                    );
                    const sortedCollections = response.sort((a, b) => {
                        const orderA = Number(a.order) || 0;
                        const orderB = Number(b.order) || 0;
                        return orderB - orderA;
                    });

                    this.allCollections = [...sortedCollections];
                    this.filtrarPorStatus();
                    this.statusFilter = '1';
                    this.numberCourses = response.length;
                    this.numberModules = response.reduce(
                        (total, collection) => total + collection.moduleQty,
                        0
                    );
                    this.numberLessons = response.reduce(
                        (total, collection) => total + collection.lessonQty,
                        0
                    );
                    this.hasReady = true;
                } catch (error) {
                    console.error('Erro ao obter dados das coleções:', error);
                }
            },
            checkMove: function (e) {},
            onDragEnd: function (e) {
                const movedElement = this.collections[e.newIndex];

                // Filtrar collections para obter apenas order e id
                const collectionOrderAndId = this.collections.map((item) => ({
                    id: item.id,
                    nome: item.comercialName,
                    order: this.collections.indexOf(item) + 1,
                }));
                this.updateCollectionOrder(collectionOrderAndId);
                this.dragging = false;
            },
            async updateCollectionOrder(collectionOrderAndId) {
                try {
                    const response = await apiCollections.updateCollectionOrder(
                        this.token,
                        collectionOrderAndId
                    );
                } catch (error) {
                    console.error('Erro ao atualizar ordem da coleção:', error);
                }
            },
            checkScreenSize() {
                this.isMobileIcon = window.innerWidth <= 600;
            },
            buscarColecao() {
                clearTimeout(this.searchDebounceTimeout);

                this.searchDebounceTimeout = setTimeout(() => {
                    let filtradas = [...this.allCollections];

                    // Aplica filtro de status
                    if (this.statusFilter !== 'all') {
                        filtradas = filtradas.filter(
                            (collection) =>
                                String(collection.status) === this.statusFilter
                        );
                    }

                    // Aplica filtro de busca
                    if (this.searchText && this.searchText.trim()) {
                        const searchLower = this.searchText
                            .toLowerCase()
                            .trim();
                        filtradas = filtradas.filter((collection) => {
                            const nameMatch = collection.comercialName
                                .toLowerCase()
                                .includes(searchLower);
                            return nameMatch;
                        });
                    }

                    this.collections = filtradas;

                    if (this.collections.length > 0) {
                        this.$nextTick(() => {
                            const firstMatch = this.collections[0];
                            const element = document.getElementById(
                                `collection-${firstMatch.id}`
                            );
                            if (element) {
                                element.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center',
                                });
                            }
                        });
                    }
                }, 300);
            },
            changeView(view) {
                this.view = view;
            },
            isCourseActive(element) {
                return String(element?.status) === '1';
            },
            stripHtmlDescription(html) {
                if (!html || typeof html !== 'string') return '';
                return html
                    .replace(/<[^>]*>/g, '')
                    .replace(/\s+/g, ' ')
                    .trim();
            },
            descriptionPreview(element) {
                const t = this.stripHtmlDescription(element?.shortDescription);
                if (!t) return '';
                const max =
                    this.view === 2
                        ? this.isMobileIcon
                            ? 42
                            : 72
                        : this.isMobileIcon
                          ? 80
                          : 140;
                return t.length > max ? `${t.slice(0, max)}…` : t;
            },
            filtrarPorStatus() {
                // Aplica o filtro de status e busca
                let filtradas = [...this.allCollections];
                if (this.statusFilter !== 'all') {
                    filtradas = filtradas.filter(
                        (collection) =>
                            String(collection.status) === this.statusFilter
                    );
                }
                // Se houver texto de busca, aplica também
                if (this.searchText.trim()) {
                    const searchLower = this.searchText.toLowerCase().trim();
                    filtradas = filtradas.filter((collection) => {
                        const nameMatch = collection.comercialName
                            .toLowerCase()
                            .includes(searchLower);
                        return nameMatch;
                    });
                }
                this.collections = filtradas;
            },
            async getStatusCourse() {
                try {
                    const response = await ApiModules.getStatusCourse(
                        this.token,
                        this.currentCollections.id
                    );
                    this.infoCount = response;
                } catch (error) {
                    console.error('Erro ao pegar status do curso:', error);
                }
            },
        },
        components: {
            Loader,
            draggable,
            TitlePage,
            VSelect,
        },
        created() {
            this.getCollections();
            this.getStatusCourse();
        },
    };
</script>
<style scoped>
    @import '@/css/weeduc/admin/courses.css';

    .edit-courses-page.weeduc-admin-courses.page-card {
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
    }

    .edit-courses-header {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem 1.5rem;
        padding: 1.25rem 1.5rem 1rem;
        background: linear-gradient(135deg, #fafbff 0%, #ffffff 100%);
        border-bottom: 1px solid #e8eaf0;
        border-radius: 16px 16px 0 0;
    }

    .edit-courses-header__lead {
        flex: 1;
        min-width: 200px;
    }

    .edit-courses-header__lead :deep(.titlelayoutGeneric) {
        border-bottom: none;
        padding-bottom: 0;
    }

    .edit-courses-header__lead :deep(.titlelayoutGeneric h3) {
        font-size: 1.5rem;
        margin: 0 0 0.35rem;
        color: #1a1d26;
    }

    .edit-courses-header__lead :deep(.titlelayoutGeneric small) {
        display: block;
        color: #5c6370;
        line-height: 1.45;
    }

    .edit-courses-header__actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.75rem;
    }

    .edit-courses-shell {
        padding: 1.25rem 1.5rem 1.5rem;
        height: calc(100vh - 210px);
        overflow-y: auto;
        min-height: 0;
        box-sizing: border-box;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .edit-courses-shell::-webkit-scrollbar {
        display: none;
    }

    .edit-courses-stats {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 1rem;
        margin-bottom: 1.25rem;
    }

    @media (max-width: 767px) {
        .edit-courses-stats {
            grid-template-columns: 1fr;
        }
    }

    .edit-courses-stat-card {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 1rem 1.25rem;
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .edit-courses-stat-card__icon {
        width: 44px;
        height: 44px;
        border-radius: 12px;
        background: #eef0fc;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .edit-courses-stat-card__icon :deep(svg) {
        color: #250891 !important;
        width: 1.25rem !important;
        height: 1.25rem !important;
    }

    .edit-courses-stat-card__body {
        display: flex;
        flex-direction: column;
        gap: 0.15rem;
        min-width: 0;
        text-align: left;
    }

    .edit-courses-stat-card__label {
        font-size: 0.75rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: #5c6370;
    }

    .edit-courses-stat-card__value {
        font-size: 1.35rem;
        font-weight: 700;
        color: #1a1d26;
        line-height: 1.2;
    }

    .edit-courses-list-panel {
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        padding: 1.25rem 1.35rem 1.35rem;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .edit-courses-list-panel__head {
        margin: 0 0 1rem;
        padding-bottom: 1rem;
        border-bottom: 1px solid #f0f2f5;
    }

    .edit-courses-list-panel__title {
        font-family:
            Inter,
            system-ui,
            -apple-system,
            sans-serif;
        font-size: 1.0625rem;
        font-weight: 700;
        color: #1a1d26;
        margin: 0 0 0.35rem;
        line-height: 1.3;
    }

    .edit-courses-list-panel__lead {
        font-size: 0.875rem;
        color: #5c6370;
        line-height: 1.5;
        margin: 0;
    }

    .edit-courses-toolbar {
        background: #fafbfc;
        border: 1px solid #f0f2f5;
        border-radius: 12px;
        padding: 1rem 1.1rem 1.1rem;
    }

    .edit-courses-toolbar__controls {
        display: grid;
        grid-template-columns: 1fr;
        gap: 0.85rem 1rem;
        align-items: end;
    }

    @media (min-width: 960px) {
        .edit-courses-toolbar__controls {
            grid-template-columns: minmax(200px, 1fr) minmax(160px, 220px) auto;
        }
    }

    .edit-courses-toolbar__field--view {
        display: flex;
        align-items: center;
    }

    .edit-courses-view-segment {
        display: flex;
        align-items: stretch;
        gap: 4px;
        padding: 4px;
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 10px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .edit-courses-seg-btn {
        flex: 1;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.4rem;
        min-height: 40px;
        padding: 0 0.65rem;
        border: none;
        border-radius: 8px;
        background: #eef0fc;
        color: #1a1d26;
        font-family:
            Inter,
            system-ui,
            -apple-system,
            sans-serif;
        font-size: 0.8125rem;
        font-weight: 500;
        cursor: pointer;
        transition:
            background 0.2s ease,
            color 0.2s ease;
    }

    .edit-courses-seg-btn:hover {
        background: #e0e4fa;
        color: #250891;
    }

    .edit-courses-seg-btn.active {
        background: #250891;
        color: #fff;
    }

    .edit-courses-seg-btn.active :deep(.v-icon) {
        color: #fff !important;
        opacity: 1;
    }

    .edit-courses-seg-btn:not(.active) :deep(.v-icon) {
        color: #250891 !important;
        opacity: 0.85;
    }

    @media (max-width: 420px) {
        .edit-courses-seg-btn__text {
            display: none;
        }

        .edit-courses-seg-btn {
            min-width: 44px;
            padding: 0 0.5rem;
        }
    }

    .edit-courses-toolbar :deep(.edit-courses-v-field .v-field) {
        border-radius: 10px;
    }

    .edit-courses-toolbar :deep(.edit-courses-v-field .v-field__outline) {
        --v-field-border-opacity: 1;
        color: #e0e2e8;
    }

    .edit-courses-toolbar :deep(.edit-courses-v-field.v-input--focused .v-field__outline) {
        color: #250891;
    }

    .edit-courses-toolbar :deep(.edit-courses-v-field .v-field--variant-outlined .v-field__outline__notch .v-field__outline__notch__label .v-label) {
        font-weight: 500;
    }

    .edit-courses-grid-wrap {
        margin-top: 1.15rem;
        padding-top: 1.1rem;
        border-top: 1px solid #f0f2f5;
    }

    /* Grade — padrão Weflix (cards proporcionais) */
    .edit-courses-list-panel :deep(.list-group.edit-courses-card-grid) {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
        gap: 1rem;
        margin: 0;
        padding: 0;
    }

    .edit-courses-list-panel :deep(.edit-courses-card-grid .edit-courses-card) {
        display: flex;
        flex-direction: column;
        min-height: 0;
    }

    .edit-courses-list-panel :deep(.edit-courses-card-grid .edit-courses-card__inner) {
        flex: 1;
        flex-direction: column;
        min-height: 312px;
        height: 100%;
    }

    .edit-courses-list-panel :deep(.edit-courses-card-grid .edit-courses-card__thumb) {
        position: relative;
        height: 168px;
        min-height: 168px;
        flex-shrink: 0;
        border-radius: 0;
        overflow: hidden;
        background-color: #eef0f3;
    }

    .edit-courses-list-panel :deep(.edit-courses-card-grid .edit-courses-card__body) {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        padding: 12px 14px 14px;
        margin: 0;
    }

    .edit-courses-list-panel :deep(.edit-courses-card-grid .edit-courses-card__text) {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        gap: 0.35rem;
    }

    /* Lista — linha compacta com miniatura */
    .edit-courses-list-panel :deep(.list-group.edit-courses-card-list) {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        width: 100%;
        height: auto;
        padding: 0;
    }

    .edit-courses-list-panel :deep(.edit-courses-card-list .edit-courses-card__inner) {
        flex-direction: row;
        align-items: center;
        min-height: 0;
        height: auto;
        padding: 10px 12px;
        gap: 12px;
    }

    .edit-courses-list-panel :deep(.edit-courses-card-list .edit-courses-card__thumb) {
        display: block !important;
        width: 64px;
        min-width: 64px;
        height: 64px;
        min-height: 64px;
        flex-shrink: 0;
        border-radius: 10px;
        overflow: hidden;
        background-color: #eef0f3;
    }

    .edit-courses-list-panel :deep(.edit-courses-card-list .edit-courses-card__body) {
        flex: 1;
        min-width: 0;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 0.2rem;
    }

    /* Shell do card (sobrescreve courses.css) */
    .edit-courses-list-panel :deep(.edit-courses-card.list-group-item) {
        padding: 0;
        margin: 0;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
        background: #fff;
        overflow: hidden;
        transition:
            border-color 0.2s ease,
            box-shadow 0.2s ease;
    }

    .edit-courses-list-panel :deep(.edit-courses-card.list-group-item:hover) {
        border-color: rgba(37, 8, 145, 0.35);
        box-shadow: 0 4px 14px rgba(37, 8, 145, 0.08);
    }

    .edit-courses-list-panel :deep(.edit-courses-card__inner) {
        display: flex;
        background: #fff;
        border-radius: inherit;
        position: relative;
    }

    .edit-courses-card__badge {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 2;
        font-size: 0.6875rem;
        font-weight: 600;
        padding: 4px 10px;
        border-radius: 999px;
        line-height: 1.2;
        letter-spacing: 0.02em;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
    }

    .edit-courses-card__badge--active {
        background: #43a047;
        color: #fff;
    }

    .edit-courses-card__badge--inactive {
        background: #e53935;
        color: #fff;
    }

    .edit-courses-list-panel :deep(.edit-courses-card__footer) {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.65rem 1rem;
        margin-top: auto;
        padding-top: 0.75rem;
        border-top: 1px solid #f0f2f5;
        font-size: 0.75rem;
        color: #5c6370;
        font-weight: 500;
    }

    .edit-courses-list-panel :deep(.edit-courses-card__footer--list) {
        border-top: none;
        padding-top: 0.35rem;
        margin-top: 0;
    }

    .edit-courses-list-panel :deep(.edit-courses-card__stat) {
        display: inline-flex;
        align-items: center;
        gap: 0.3rem;
    }

    .edit-courses-list-panel :deep(.edit-courses-card__stat-icon) {
        color: #250891;
        opacity: 0.9;
    }

    .edit-courses-list-panel :deep(.edit-courses-card__stat--ok) {
        color: #2e7d32;
        font-weight: 600;
    }

    .edit-courses-list-panel :deep(.edit-courses-card__stat--off) {
        color: #c62828;
        font-weight: 600;
    }

    .edit-courses-list-panel :deep(.edit-courses-card__stat-sep) {
        color: #c5cad3;
        user-select: none;
    }

    .edit-courses-list-panel :deep(.edit-courses-card-grid .edit-courses-card-title) {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        overflow: hidden;
    }

    .edit-courses-list-panel :deep(.itemContent .titleItemCollection) {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0.35rem;
        text-align: left;
        white-space: normal;
        overflow: visible;
        text-overflow: unset;
    }

    .edit-courses-card-title {
        display: block;
        font-weight: 700;
        font-size: 1rem;
        line-height: 1.35;
        color: #1a1d26;
    }

    .edit-courses-card-desc {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        overflow: hidden;
        font-size: 0.8125rem;
        line-height: 1.45;
        color: #5c6370;
        margin: 0;
        white-space: normal;
        word-break: break-word;
    }

    .edit-courses-list-panel
        :deep(.list-group.edit-courses-card-list .edit-courses-card-desc) {
        -webkit-line-clamp: 1;
        line-clamp: 1;
    }

    .edit-courses-empty {
        text-align: center;
        padding: 1.5rem 0.75rem 0.25rem;
        color: #7a8190;
        font-size: 0.9375rem;
    }

    .status-filter {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .status-filter label {
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        gap: 3px;
    }
    .status-filter input[type='radio'] {
        accent-color: #250891;
    }
    /* O select nativo não é mais usado, mas mantive o estilo para compatibilidade */
    .status-filter select {
        background-color: #fff !important;
        color: #250891 !important;
        border: 1px solid #250891 !important;
        padding: 4px 8px !important;
        border-radius: 4px !important;
        font-size: 16px !important;
        transition: border-color 0.3s, box-shadow 0.3s !important;
        outline: none !important;
        box-shadow: none !important;
        font-family: inherit !important;
        border: 1px solid #cccccc !important;
        text-align: center;
        font-size: 15px !important;
    }

    .status-filter select:focus {
        border-color: #160266;
        box-shadow: 0 0 0 2px rgba(37, 8, 145, 0.1);
    }

    .status-filter select option {
        color: #250891;
        background: #fff;
    }

    /* Estilos adicionais para garantir que o background seja aplicado */
    .backgroundItemCollection {
        min-height: 200px;
        width: 100%;
        display: block;
    }

    .backgroundItemCollection.noImage {
        background-color: #f5f5f5;
    }
</style>

<style>
    /**
     * Dark mode — Meus Cursos (weeduc-admin-courses / edit-courses-page)
     * Palleta alinhada ao dashboard (.dashboard.dark) e sem o cinza #575757 legado nos cards.
     */
    .dashboard.dark .weeduc-admin-courses.edit-courses-page.page-card {
        background: #1c1d24;
        border: 1px solid #2f323c;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-header {
        background: linear-gradient(145deg, #23252e 0%, #1c1d24 100%);
        border-bottom-color: #353945;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-header__lead .titlelayoutGeneric h3 {
        color: #f1f3f7;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-header__lead .titlelayoutGeneric small {
        color: #9ca3b4;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-stat-card {
        background: #252730;
        border-color: #353945;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-stat-card__icon {
        background: #323643;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-stat-card__icon svg {
        color: #b4a9f0 !important;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-stat-card__label {
        color: #9ca3b4;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-stat-card__value {
        color: #f1f3f7;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-list-panel {
        background: #252730;
        border-color: #353945;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-list-panel__head {
        border-bottom-color: #353945;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-list-panel__title {
        color: #f1f3f7;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-list-panel__lead {
        color: #9ca3b4;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-toolbar {
        background: #2a2d36;
        border-color: #3d414d;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-view-segment {
        background: #323643;
        border-color: #454a5a;
        box-shadow: none;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-seg-btn {
        background: #353945;
        color: #e4e6ed;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-seg-btn:hover {
        background: #3d4252;
        color: #d8d0fc;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-seg-btn.active {
        background: #5c4fc9;
        color: #fff;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-seg-btn.active .v-icon {
        color: #fff !important;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-seg-btn:not(.active) .v-icon {
        color: #b4a9f0 !important;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-grid-wrap {
        border-top-color: #353945;
    }

    /* Campos Vuetify (tema light no DOM) — harmonizar com o painel escuro */
    .dashboard.dark .weeduc-admin-courses .edit-courses-toolbar .v-field--variant-outlined {
        --v-field-border-opacity: 1;
        background: #323643;
        color: #f1f3f7;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-toolbar .v-field__outline {
        color: #454a5a !important;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-toolbar .v-field--focused .v-field__outline {
        color: #7c6fd4 !important;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-toolbar .v-field__input,
    .dashboard.dark .weeduc-admin-courses .edit-courses-toolbar .v-select__selection,
    .dashboard.dark .weeduc-admin-courses .edit-courses-toolbar .v-select__selection-text {
        color: #f1f3f7 !important;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-toolbar .v-label,
    .dashboard.dark .weeduc-admin-courses .edit-courses-toolbar .v-field-label {
        color: #9ca3b4 !important;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-toolbar .v-field--focused .v-field-label--floating,
    .dashboard.dark .weeduc-admin-courses .edit-courses-toolbar .v-field--active .v-field-label--floating {
        color: #b4a9f0 !important;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-toolbar .v-icon {
        color: #9ca3b4 !important;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-toolbar .v-field--appended .v-field__append-inner .v-icon {
        opacity: 0.9;
    }

    /* Cards de curso */
    .dashboard.dark .weeduc-admin-courses .edit-courses-list-panel .edit-courses-card.list-group-item {
        background: #2a2d36;
        border-color: #454a5a;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-list-panel .edit-courses-card.list-group-item:hover {
        border-color: rgba(124, 111, 212, 0.55);
        box-shadow: 0 4px 18px rgba(92, 79, 201, 0.2);
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-list-panel .edit-courses-card__inner {
        background: #2a2d36;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-list-panel .edit-courses-card-grid .edit-courses-card__thumb,
    .dashboard.dark .weeduc-admin-courses .edit-courses-list-panel .edit-courses-card-list .edit-courses-card__thumb {
        background-color: #323643;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-list-panel .edit-courses-card__footer {
        border-top-color: #3d414d;
        color: #9ca3b4;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-list-panel .edit-courses-card__stat-icon {
        color: #b4a9f0 !important;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-card-title {
        color: #f1f3f7;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-card-desc {
        color: #9ca3b4;
    }

    .dashboard.dark .weeduc-admin-courses .edit-courses-empty {
        color: #9ca3b4;
    }

    .dashboard.dark .weeduc-admin-courses.edit-courses-page .backgroundItemCollection.noImage {
        background-color: #323643;
    }

    .dashboard.dark .weeduc-admin-courses .drag-handle {
        background: rgba(42, 45, 54, 0.95);
        color: #b4a9f0;
    }

    .dashboard.dark .weeduc-courses-select-menu-dark {
        background: #323643 !important;
        border: 1px solid #454a5a;
    }

    .dashboard.dark .weeduc-courses-select-menu-dark .v-list {
        background: #323643 !important;
        color: #f1f3f7;
    }

    .dashboard.dark .weeduc-courses-select-menu-dark .v-list-item-title {
        color: #f1f3f7 !important;
    }

    .dashboard.dark .weeduc-courses-select-menu-dark .v-list-item--active .v-list-item-title {
        color: #d8d0fc !important;
    }
</style>
